import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/translations';
import './DiferenciacaoSection.css';

const iconProps = {
  className: 'diferenciacao-icon',
  viewBox: '0 0 48 48',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
};

function DiferenciacaoIcon({ name }) {
  switch (name) {
    case 'villa':
      return (
        <svg {...iconProps}>
          <path
            d="M8 22L24 10l16 12v18H8V22z"
            stroke="currentColor"
            strokeWidth="1.35"
            strokeLinejoin="round"
          />
          <path d="M18 40V26h12v14" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
        </svg>
      );
    case 'pool':
      return (
        <svg {...iconProps}>
          <path
            d="M10 32c2.5 2 6.5 2 9 0s6.5-2 9 0 6.5 2 9 0"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
          />
          <path
            d="M10 36c2.5 2 6.5 2 9 0s6.5-2 9 0 6.5 2 9 0"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
          />
          <path
            d="M24 28v-6M24 22c-2-2-2-5 0-6.5s4-1.5 5.5 0"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
          />
          <path
            d="M24 22c2-2 2-5 0-6.5s-4-1.5-5.5 0"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'lock':
      return (
        <svg {...iconProps}>
          <rect
            x="14"
            y="22"
            width="20"
            height="16"
            rx="2"
            stroke="currentColor"
            strokeWidth="1.35"
          />
          <path
            d="M18 22v-5a6 6 0 0112 0v5"
            stroke="currentColor"
            strokeWidth="1.35"
            strokeLinecap="round"
          />
          <circle cx="24" cy="30" r="2" fill="currentColor" />
        </svg>
      );
    case 'tree':
      return (
        <svg {...iconProps}>
          <path d="M24 40V28" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
          <path
            d="M24 28c-4-4-4-10 0-14s8 2 8 8-4 10-8 6"
            stroke="currentColor"
            strokeWidth="1.35"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18 30c-3-2-3-7 0-9M30 30c3-2 3-7 0-9"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'porto':
      return (
        <svg {...iconProps}>
          <path
            d="M8 38V22l4-2v6l3-1v-5l3-1v8l3-1v-6l3-1v10l3-1v-7l3-1v12"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
          <path
            d="M22 14v10l2 1V14c0-2 2-3 4-3s4 1 4 3v11l2-1V14"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'superhost':
      return (
        <svg {...iconProps}>
          <path
            d="M24 10c-6 0-10 4-10 9 0 5 4 9 10 14 6-5 10-9 10-14 0-5-4-9-10-9z"
            stroke="currentColor"
            strokeWidth="1.35"
            strokeLinejoin="round"
          />
          <path
            d="M18 19c2 3 5 4 6 4s4-1 6-4"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'star':
      return (
        <svg {...iconProps}>
          <path
            d="M24 11l2.8 6.4 6.9.6-5.2 4.5 1.6 6.7L24 26.4l-6.1 3.8 1.6-6.7-5.2-4.5 6.9-.6L24 11z"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'ev':
      return (
        <svg {...iconProps}>
          <rect
            x="12"
            y="14"
            width="24"
            height="22"
            rx="2"
            stroke="currentColor"
            strokeWidth="1.35"
          />
          <path d="M18 36v4M30 36v4" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
          <path
            d="M22 22l-3 6h4l-2 6 6-8h-4l2-4"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinejoin="round"
          />
        </svg>
      );
    default:
      return null;
  }
}

function DiferenciacaoSection() {
  const { language } = useLanguage();
  const t = translations?.[language]?.diferenciacao || translations.en.diferenciacao;

  return (
    <section className="diferenciacao-section" aria-labelledby="diferenciacao-heading">
      <div className="diferenciacao-section__decor diferenciacao-section__decor--tl" aria-hidden />
      <div className="diferenciacao-section__decor diferenciacao-section__decor--br" aria-hidden />
      <div className="diferenciacao-section__frame">
        <div className="diferenciacao-section__inner">
          <p className="diferenciacao-kicker">{t.kicker}</p>
          <div className="diferenciacao-ornament" aria-hidden>
            <span className="diferenciacao-ornament__line" />
            <svg
              className="diferenciacao-ornament__leaf"
              viewBox="0 0 32 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 4c-4 4-6 8-6 12 0 3 2 6 6 8M16 4c4 4 6 8 6 12 0 3-2 6-6 8M16 4v16"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="diferenciacao-ornament__line" />
          </div>
          <h2 id="diferenciacao-heading" className="diferenciacao-title">
            {t.title}
          </h2>
          <p className="diferenciacao-lead">{t.lead}</p>
          <div className="diferenciacao-grid" role="list">
            {t.items.map((item) => (
              <div key={item.title} className="diferenciacao-grid__cell" role="listitem">
                <div className="diferenciacao-grid__iconWrap">
                  <DiferenciacaoIcon name={item.icon} />
                </div>
                <h3 className="diferenciacao-grid__title">{item.title}</h3>
                <p className="diferenciacao-grid__subtitle">{item.subtitle}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default DiferenciacaoSection;
